import React, { useCallback } from 'react';
import { inputsV2 } from '@ecosystem/newron-design-system';

import { SelectConfigItem } from '../types';
import { ConfigItemElementProps } from './types';

const { Select } = inputsV2;

function SelectElement({
  configItem: { label, key, placeholder, options, value: actual, combobox, tooltipInfo, disabled, isLoading },
  onChange,
  onRequestOptions,
}: Readonly<ConfigItemElementProps<SelectConfigItem>>) {
  const handleChange = (value: string) => {
    const entity = options.find(o => o.value === value) || { value: undefined, label: undefined };
    onChange(key, { ...entity });
  };

  const handleMenuOpen = useCallback(() => {
    onRequestOptions?.(key);
  }, [key, onRequestOptions]);

  return (
    <Select
      placeholder={placeholder ?? 'Any'}
      label={label}
      options={options}
      value={actual?.value}
      disabled={disabled}
      onChange={handleChange}
      combobox={combobox}
      tooltipInfo={tooltipInfo}
      tooltipPlacement="top"
      isLoading={isLoading}
      onMenuOpen={handleMenuOpen}
    />
  );
}

export { SelectElement };
